function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import ExpandIfX from './ExpandIfX';
import PropTypes from 'prop-types';

function pad(num, size) {
  var s = String(num);
  while (s.length < size) {
    s = '0' + s;
  }
  return s;
}

var ExpandIfAge = function (_ExpandIfX) {
  _inherits(ExpandIfAge, _ExpandIfX);

  function ExpandIfAge() {
    var _temp, _this, _ret;

    _classCallCheck(this, ExpandIfAge);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _ExpandIfX.call.apply(_ExpandIfX, [this].concat(args))), _this), _this.watchForUpdates = function () {
      return ['birth_month', 'birth_date', 'birth_year'];
    }, _this.show = function (key, value) {
      var _this$props = _this.props,
          defaultShow = _this$props.defaultShow,
          maxAge = _this$props.maxAge,
          minAge = _this$props.minAge;

      var form = _this.context.form;

      var values = _this.watchForUpdates().map(function (field) {
        return field === key ? value : form.get(field);
      });

      var month = values[0];
      var date = values[1];
      var year = values[2];

      if (month !== '' && date !== '' && year !== '') {
        var isoDate = pad(year, 4) + '-' + pad(month, 2) + '-' + pad(date, 2);
        var age = _this.getAge(isoDate);
        if (minAge !== undefined) {
          return age >= minAge;
        } else if (maxAge !== undefined) {
          return age <= maxAge;
        }
      }

      return defaultShow;
    }, _this.getAge = function (isoDate) {
      var today = new Date();
      var bday = new Date(isoDate);

      var m = today.getMonth() - bday.getMonth();
      var age = today.getFullYear() - bday.getFullYear();
      var notYet = m < 0 || m === 0 && today.getDate() < bday.getDate();

      return notYet ? age - 1 : age;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return ExpandIfAge;
}(ExpandIfX);

ExpandIfAge.contextTypes = {
  form: PropTypes.object.isRequired
};

ExpandIfAge.propTypes = {
  defaultShow: PropTypes.bool.isRequired,
  maxAge: PropTypes.number,
  minAge: PropTypes.number
};

export default ExpandIfAge;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/ExpandIfAge.js
// module id = 696
// module chunks = 0